module.exports = __webpack_public_path__ + "img/concrete-outer-corner.e6749833.png";